/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

export const authSettings = {
  guest: {},
  user: {
    view: [
      "profile",
      "dashboard",
      "processing",
      "audit",
      "reports",
      "user-guide",
      "tools",
      "arriving-hardware",
      "support",
      "stock-report",
    ],
    edit: ["profile", "dashboard", "processing", "audit", "arriving-hardware", "stock-report"],
  },
  operations_admin: {
    view: [
      "dashboard",
      "processing",
      "audit",
      "arriving-hardware",
      "profile",
      "management",
      "reports",
      "sales-orders",
      "user-guide",
      "tools",
      "sales-report",
      "support",
      "stock-report"
    ],
    edit: [
      "dashboard",
      "processing",
      "audit",
      "arriving-hardware",
      "profile",
      "management",
      "reports",
      "sales-orders",
      "user-guide",
      "tools",
      "sales-report",
      "support",
      "stock-report"
    ],
  },
  admin: {
    view: "*",
    edit: "*",
  },
};
